import { axios } from 'api'

type ContactUsFormValues = {
  firstName: string
  lastName: string
  phoneNumber: string
  email: string
  comments: string
}

type SendContactUsResponse =
  | { success: true }
  | { success: false; error: string }
const sendContactUs = async (
  formData: ContactUsFormValues
): Promise<SendContactUsResponse> => {
  const response = await axios.post('/contact-us', formData)

  if (response.status === 200) {
    return { success: true }
  } else {
    return {
      success: false,
      error:
        response.data.error || 'Failed to send your message. Please try again.'
    }
  }
}

export default sendContactUs
